"use client";

import { usePathname, useRouter } from "i18n/routing";
import { useEffect } from "react";
import type { BlogPostType } from "types/blog-type";
import { useMixpanelTrackScrolling } from "utils/hooks";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";

export function BlogClient({ blogPost }: { blogPost: BlogPostType }) {
  const router = useRouter();
  const pathname = usePathname();
  const { country } = useCountryStateCookies();

  useMixpanelTrackScrolling({
    mixpanelEventName: "Scrolled on blog article",
    properties: {
      "article name": blogPost?.title ? blogPost.title : pathname
    }
  });

  useEffect(() => {
    if (country && blogPost?.restrictedCountryList.includes(country)) {
      router.push(country === "GB" ? "/uk" : "/");
    }
  }, [country, blogPost.restrictedCountryList, router]);

  return null;
}
